module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.data.title) ? _c('h3', {
    staticClass: "grid__title"
  }, [_vm._v("\n    " + _vm._s(_vm.data.title) + "\n    "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid__content"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "grid__options"
  }, [_c('i')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ed9fc94!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/layout/grid/Tile.vue
// module id = 751
// module chunks = 1